const GetFormatTime = (dataAtual, withUtc = true, withSeconds = true) => {
  if (withUtc === true) {
    const data = new Date(dataAtual);

    const dataUTC3 = new Date(data.getTime() - 3 * 60 * 60 * 1000);

    const hora = String(dataUTC3.getHours()).padStart(2, "0");
    const minutos = String(dataUTC3.getMinutes()).padStart(2, "0");
    const segundos = String(dataUTC3.getSeconds()).padStart(2, "0");

    return withSeconds
      ? `${hora}:${minutos}:${segundos}`
      : `${hora}:${minutos}`;
  }
  const data = new Date(dataAtual);

  const hora = String(data.getHours()).padStart(2, "0");
  const minutos = String(data.getMinutes()).padStart(2, "0");
  const segundos = String(data.getSeconds()).padStart(2, "0");

  return withSeconds ? `${hora}:${minutos}:${segundos}` : `${hora}:${minutos}`;
};

export default GetFormatTime;
